export default __webpack_public_path__ + "static/media/logo.450f194d.svg";